import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function PhilosophySection() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation(0.08);
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation(0.08);

  return (
    <section id="philosophy" className="py-28 px-6 bg-[#FEFCFA]">
      <div className="max-w-5xl mx-auto">
        <div
          ref={titleRef}
          className={`text-center mb-20 fade-in ${titleVisible ? 'visible' : ''}`}
        >
          <p className="text-[#C97B7B] text-xs tracking-[0.5em] mb-4 uppercase">About Us</p>
          <h2 className="text-[#3A2E28] text-3xl md:text-4xl font-light mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            私たちについて
          </h2>
          <div className="w-10 h-px bg-[#C8B99A] mx-auto" />
        </div>

        {/* 2カラム：左テキスト・右画像 */}
        <div className="flex flex-col md:flex-row gap-16 items-center mb-24">
          <div
            ref={leftRef}
            className={`w-full md:w-1/2 fade-in-left ${leftVisible ? 'visible' : ''}`}
          >
            <p
              className="text-[#C97B7B] text-xs tracking-[0.4em] mb-6 uppercase"
            >
              Our Story
            </p>
            <h3
              className="text-[#3A2E28] text-2xl md:text-3xl font-light leading-relaxed mb-8"
              style={{ fontFamily: 'Noto Serif JP, serif' }}
            >
              赤ちゃんの存在は、<br />
              かけがえのない<br />
              命の証です。
            </h3>
            <div className="w-8 h-px bg-[#C8B99A] mb-8" />
            <p className="text-[#6B5E57] text-sm leading-[2.2] mb-6">
              Hugは、人と人、そして命をやさしくつなぐことを大切にしている会社です。
            </p>
            <p className="text-[#6B5E57] text-sm leading-[2.2] mb-6">
              死産や未熟児など、小さな命との別れを経験されたご家族へ。<br />
              ほんの短い時間でも、その子が生まれてきた証を大切に残してほしい。
            </p>
            <p className="text-[#3A2E28] text-sm leading-[2.2] font-medium" style={{ fontFamily: 'Noto Serif JP, serif' }}>
              小さなぬくもりが誰かの支えになる。<br />
              そんな社会を目指しています。
            </p>
          </div>

          <div
            ref={rightRef}
            className={`w-full md:w-1/2 fade-in-right ${rightVisible ? 'visible' : ''}`}
          >
            <div className="relative">
              <div style={{ width: '100%', height: '480px' }} className="rounded-lg overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/f95542f0baf3f48f84068e288a896fe7.jpg"
                  alt="ベビー服"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* アクセントカード */}
              <div
                className="absolute -bottom-6 -left-6 bg-white rounded-lg px-6 py-5 hidden md:block"
                style={{ border: '1px solid #F0E4E4' }}
              >
                <p className="text-[#C97B7B] text-xs tracking-widest mb-1">Hug</p>
                <p className="text-[#3A2E28] text-sm font-medium" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                  命のぬくもりを<br />未来へ。
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 2つの柱カード */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-2xl mx-auto">
          {[
            {
              icon: 'ri-heart-line',
              title: '命',
              desc: 'かけがえのない命の証。大切な記憶に寄り添い、形に残す',
              color: '#C97B7B',
              bg: '#F7EDED',
            },
            {
              icon: 'ri-links-line',
              title: 'つながり',
              desc: '小さなぬくもりが誰かの支えになる。人と人をやさしくつなぐ',
              color: '#A8835A',
              bg: '#F5EEE5',
            },
          ].map((p) => (
            <div
              key={p.title}
              className="rounded-lg p-8 text-center"
              style={{ backgroundColor: p.bg }}
            >
              <div
                className="w-11 h-11 flex items-center justify-center rounded-full mx-auto mb-4"
                style={{ backgroundColor: `${p.color}18` }}
              >
                <i className={`${p.icon} text-lg`} style={{ color: p.color }} />
              </div>
              <h3
                className="text-sm font-medium mb-2 tracking-wider"
                style={{ color: p.color, fontFamily: 'Noto Serif JP, serif' }}
              >
                {p.title}
              </h3>
              <p className="text-[#6B5E57] text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
